// src/pages/SetPasswordPage.tsx
import React, { useState } from 'react'
import { supabase } from '../lib/supabaseClient'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { Button } from '../components/ui/Button'
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/Card'
import { ArrowLeft } from 'lucide-react'

export default function SetPasswordPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string>()
  const [message, setMessage] = useState<string>()
  const [loading, setLoading] = useState(false)
  const email = new URLSearchParams(location.search).get('email') || ''

  const handleSubmit = async () => {
    setError(undefined)
    setMessage(undefined)
    setLoading(true)
    const { error: updateError } = await supabase.auth.updateUser({ password })
    setLoading(false)
    if (updateError) {
      setError(updateError.message)
    } else {
      setMessage('✅ Password set! Redirecting...')
      setTimeout(() => navigate('/app/calendar'), 1000)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md mb-6">
        <Button 
  as={Link} 
  to="/" 
  variant="ghost" 
  className="flex items-center text-gray-700 hover:text-gray-950 transition-colors !rounded-full px-6 py-2"
>
          <ArrowLeft size={18} className="mr-2" />
          Back
        </Button>
      </div>
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle>Set Your Password</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <p className="text-sm text-gray-600 text-center">for: <strong>{email}</strong></p>
            <label className="block text-sm font-medium text-gray-700">New Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="mt-1 w-full p-2 border rounded"
            />
            {error && <p className="text-red-600 text-sm">{error}</p>}
            {message && <p className="text-green-600 text-sm">{message}</p>}
            <Button 
  onClick={handleSubmit} 
  disabled={!password || loading} 
  fullWidth
  className={`!rounded-full py-3 text-lg font-medium shadow-md hover:shadow-lg transition-all duration-300 ${
    !password || loading 
      ? 'bg-gray-400 text-white cursor-not-allowed' 
      : 'bg-black hover:bg-gray-900 text-white'
  }`}
>
  {loading ? 'Saving…' : 'Save Password'}
</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
